(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-ir-wrap-gallery-v5]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const image = root.querySelector('[data-ir-gallery-image]');
      const stage = root.querySelector('[data-ir-gallery-stage]');
      const thumbs = [...root.querySelectorAll('[data-ir-gallery-thumb]')];
      const rail = root.querySelector('[data-ir-gallery-thumbs]');
      const mobile = matchMedia('(max-width:640px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, start = null, track = null, scrollFrame = null;
      if (!thumbs.length) return;

      function select(index, scrollThumb = true) {
        current = (index + thumbs.length) % thumbs.length;
        const selected = thumbs[current];
        image.src = selected.dataset.image;
        image.alt = selected.dataset.alt;
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === current)));
        root.querySelector('[data-ir-gallery-status]').textContent = `Image ${current + 1} of ${thumbs.length}`;
        if (scrollThumb) rail.scrollTo({
          left: selected.offsetLeft - rail.offsetLeft - (rail.clientWidth - selected.clientWidth) / 2,
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
      }
      function go(index) {
        select(index);
        if (mobile.matches && track) track.scrollTo({
          left: current * track.clientWidth,
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
      }
      function prepareMobileTrack() {
        if (!mobile.matches) return;
        if (!track) {
          track = document.createElement('div');
          track.className = 'ir-wrap-gallery-v5__slides';
          track.setAttribute('data-ir-gallery-slides', '');
          thumbs.forEach((thumb, index) => {
            const slide = document.createElement('div');
            slide.className = 'ir-wrap-gallery-v5__slide';
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', `Image ${index + 1} of ${thumbs.length}`);
            const slideImage = document.createElement('img');
            slideImage.src = thumb.dataset.image;
            slideImage.alt = thumb.dataset.alt;
            slideImage.width = 1080;
            slideImage.height = 1080;
            slideImage.loading = index === 0 ? 'eager' : 'lazy';
            slideImage.fetchPriority = index === 0 ? 'high' : 'low';
            slideImage.decoding = 'async';
            slideImage.draggable = false;
            slide.append(slideImage);
            track.append(slide);
          });
          stage.append(track);
          track.addEventListener('scroll', () => {
            if (scrollFrame !== null) cancelAnimationFrame(scrollFrame);
            scrollFrame = requestAnimationFrame(() => {
              scrollFrame = null;
              if (!mobile.matches || !track.clientWidth) return;
              const index = Math.round(track.scrollLeft / track.clientWidth);
              if (index !== current) select(index);
            });
          }, {passive: true});
          // Native scrolling stops at the ends. A further swipe uses the same wrap action as the arrows.
          let edgeTouch = null, edgePointer = null;
          function wrapEdgeSwipe(start, endX, endY) {
            if (!start || !mobile.matches) return;
            const dx = endX - start.x, dy = endY - start.y;
            if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
            if (start.index === thumbs.length - 1 && dx < 0) go(0);
            else if (start.index === 0 && dx > 0) go(thumbs.length - 1);
          }
          track.addEventListener('touchstart', event => {
            if (event.touches.length !== 1) return;
            const touch = event.touches[0];
            edgeTouch = {x: touch.clientX, y: touch.clientY, index: current};
          }, {passive: true});
          track.addEventListener('touchend', event => {
            const touch = event.changedTouches[0];
            if (touch) wrapEdgeSwipe(edgeTouch, touch.clientX, touch.clientY);
            edgeTouch = null;
          }, {passive: true});
          track.addEventListener('touchcancel', () => { edgeTouch = null; }, {passive: true});
          track.addEventListener('pointerdown', event => {
            if (event.pointerType === 'touch') return;
            edgePointer = {x: event.clientX, y: event.clientY, index: current};
          });
          track.addEventListener('pointerup', event => {
            if (event.pointerType !== 'touch') wrapEdgeSwipe(edgePointer, event.clientX, event.clientY);
            edgePointer = null;
          });
          track.addEventListener('pointercancel', () => { edgePointer = null; });
          new ResizeObserver(() => {
            if (mobile.matches && track.clientWidth) track.scrollTo({left: current * track.clientWidth, behavior: 'instant'});
          }).observe(track);
        }
        track.scrollTo({left: current * track.clientWidth, behavior: 'instant'});
      }
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => go(index)));
      root.querySelector('[data-ir-gallery-prev]').addEventListener('click', () => go(current - 1));
      root.querySelector('[data-ir-gallery-next]').addEventListener('click', () => go(current + 1));
      stage.addEventListener('keydown', event => {
        if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          go(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      stage.addEventListener('pointerdown', event => {
        if (mobile.matches) return;
        start = {x: event.clientX, y: event.clientY};
        stage.setPointerCapture(event.pointerId);
      });
      stage.addEventListener('pointerup', event => {
        if (!start || mobile.matches) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', () => { start = null; });
      mobile.addEventListener('change', prepareMobileTrack);
      select(0, false);
      prepareMobileTrack();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
